import { useMemo } from 'react'
import { v4 as uuidv4 } from 'uuid';

import getConfig from 'next/config'

import storage from '@/utils/storage'

export default function useFakeId() {
  return useMemo(() => {

    if (getConfig().serverRuntimeConfig.runtime === 'server') {
      return ''
    }

    const fakeId = storage.getLocalStorage('fake_dis_id') || uuidv4()
    storage.setLocalStorage('fake_dis_id', fakeId)
    return fakeId
  }, [])
}
